export default "__VITE_ASSET__ibP8qQLC__"